<template lang="pug">
div.pt-0.pb-8
  div.d-flex.align-center
    v-spacer
    v-btn.button-sm(color="primary" outlined @click="addNewProvider")
      v-icon(left) mdi-plus
      | {{ $t('new_provider') }}
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
  template(v-else)
    template(v-if="providers.length > 0")
      v-card.round-xl.mt-6(outlined)
        template(v-for="(provider, pidx) in providers")
          div.pa-6.d-flex.align-center(:key="'provider-' + pidx")
            v-avatar(size="48" color="neutral300")
              template(v-if="provider.profile_image")
                v-img(:src="`https://img.yezza.io/100x100/${provider.profile_image.path}`")
              v-icon(v-else color="neutral500" size="30") $yzi-user-03
            div.ml-6
              div
                span.text-md.font-medium.neutral700--text {{ provider.name }}
                span.text-sm.neutral500--text.ml-2 {{ provider.type }}
              div.text-sm.neutral700--text(v-if="provider.services.length") {{ $t('service') }}: {{ provider.services.join(', ') }}
            v-spacer
            div
              y-switch.mb-n2(v-model="provider.enabled" @change="changeStatus(provider)")
            v-menu(offset-y left rounded="lg" attach)
              template(#activator="{ on }")
                v-btn.ml-4(icon small v-on="on")
                  v-icon mdi-dots-horizontal
              v-list(dense)
                v-list-item(@click="editProvider(provider)")
                  v-list-item-title.text-sm.basic800--text {{ $t('edit_provider') }}
                v-divider
                v-list-item(@click="deleteProvider(provider)")
                  v-list-item-title.text-sm.danger500--text {{ $t('delete_provider') }}
            
          v-divider(v-if="pidx !== (providers.length - 1)")

    div.empty-box.mt-6.pa-8(v-else align="center")
      v-avatar(color="neutral300" size="54")
        v-icon(color="neutral500" size="30") $yzi-users-02
      div.text-center.text-md.font-semibold.neutral700--text.mt-8 {{ $t('empty_providers') }}
      div.text-center.text-sm.font-normal.neutral500--text.mt-1 {{ $t('empty_providers_desc') }}
      v-btn.button-sm.mt-8(color="primary" outlined @click="addNewProvider") {{ $t('create_provider') }}
  br
  br
  .dialogs
    delete-provider-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :provider="selectedProvider" @deleted="successDeleteProvider")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteProviderDialog from '@/components/clinic/dialogs/DeleteProviderDialog.vue'

export default {
  name: 'ManageProvider',
  components: { DeleteProviderDialog },
  data () {
    return {
      isFetching: false,
      showDeleteDialog: false,
      selectedProvider: null,
      providers: []
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  mounted () {
    this.fetchProviders()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProviders () {
      this.isFetching = true
      let params = {
        page_size: -1
      }
      this.$axios.get(`/clinics/${this.company.slug}/providers`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.providers = resp.data.results.map(m =>  { return { ...m, enabled: m.status === 'active' }})
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    addNewProvider () {
      this.$router.push('/admin/clinic/manage/provider')
    },
    editProvider (provider) {
      this.$router.push(`/admin/clinic/manage/provider/${provider.id}`)
    },
    deleteProvider (provider) {
      this.selectedProvider = provider
      this.showDeleteDialog = true
    },
    successDeleteProvider () {
      this.fetchProviders()
      this.selectedProvider = null
    },
    changeStatus (provider) {
      this.$axios.patch(`/clinics/${this.company.slug}/providers/${provider.id}`, { status: provider.enabled ? 'active' : 'inactive' })
        .then(resp => {
          this.$set(provider, 'status', resp.data.status)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
</style>